import React from 'react';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import { noop } from 'lodash';

const PAYMENT_SETTINGS = [
    {
        refValue: 13,
        code: 'onHoldEnabled',
        title: 'Payment On Hold'
    },
    {
        refValue: 14,
        code: 'enablePayByPoints',
        title: 'Allow guests to pay with Points'
    },
    {
        refValue: 15,
        code: 'displayVatBillingAddressFields',
        title: 'Display VAT Billing Address Fields'
    },
    {
        refValue: 16,
        code: 'disableUplift',
        title: 'Disable Buy Now Pay Later'
    },
    {
        refValue: 17,
        code: 'enableExpressCheckout',
        title: 'Display Express Checkout option (requires activation in Control Center)'
    }
];

const PaymentSettings = ({
    currentConfigCopy = {},
    isDisabled = false,
    registerSection,
    sectionStyleHandler,
    toggleConfigBoolean = noop
}) => {

    return (
        <section
            className="row spark-panel__content"
            ref={registerSection(12)}
            style={sectionStyleHandler(12)}
        >
            <div className="col-xs-12">
                <h4>Payment Settings</h4>
                {PAYMENT_SETTINGS.map((setting, index) => (
                    <ConfigurationCheckbox
                        key={`payment-setting-${index}`}
                        title={setting.title}
                        ref={registerSection(setting.refValue)}
                        style={sectionStyleHandler(setting.refValue)}
                        isDisabled={isDisabled}
                        code={setting.code}
                        onChange={toggleConfigBoolean}
                        value={currentConfigCopy[setting.code]}
                    />
                ))}
            </div>
        </section>
    )
};

export default PaymentSettings;


// WEBPACK FOOTER //
// ./src/components/pages/pages/guestPayment/payment-settings.js